import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-intl-redux'
import store from './store/index'
import App from './App'
import * as serviceWorker from './serviceWorker'
import 'antd/dist/antd.css'
import VersionNotice from './components/version-notice/VersionNotice'
import './index.css'

// KAN-44: VersionNotice va al lado de <App/>, no envolviéndolo. El CacheBuster
// original lo envolvía y no renderizaba nada mientras chequeaba la versión, así
// que un meta.json lento dejaba la pantalla en blanco.
//
// El Fragment es necesario: el Provider de react-intl-redux monta un
// IntlProvider, que en react-intl 2.x hace Children.only y revienta con dos
// hijos sueltos.
ReactDOM.render(
  <Provider store={store}>
    <React.Fragment>
      <App />
      <VersionNotice />
    </React.Fragment>
  </Provider>, document.getElementById('root'))
serviceWorker.register()
